import React from "react";
import TrackOrderSection from "./TrackOrderSection";

/**
 * OrderDetailSection
 *
 * Renders full order details, live tracking timeline, shipment progress,
 * and delivery breakdown for a selected order.
 */
export const OrderDetailSection = (props) => {
  return <TrackOrderSection {...props} />;
};

export default OrderDetailSection;
